



















import { Component, Vue } from 'vue-property-decorator'

@Component({
  name: 'Footer',
  components: {
  }
})

export default class Footer extends Vue {
  t (key: string) {
    return this.$t(`Footer.${key}`)
  }
}
